/* eslint-disable @typescript-eslint/camelcase */
import { CariSttRequest, CariSttEntities } from "@/domain/entities/ListCariSTT";
import { Action, getModule, Module, VuexModule } from "vuex-module-decorators";
import { ListCariSTTPresenter } from "../presenters/ListCariSTTPresenter";
import { container } from "tsyringe";
import store from "@/store";
import { ListCariSTTComponent } from "@/app/infrastructures/dependencies/modules/ListCariSTTComponent";
import {
  SearchSttFilter,
  SearchSttScanApiRequest
} from "@/data/payload/api/CariSttApiRequest";

ListCariSTTComponent.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "list-cari-stt"
})
class ListCariSTTStore extends VuexModule {
  @Action
  async getListCariSTT(params: CariSttRequest) {
    const presenter = container.resolve(ListCariSTTPresenter);
    return presenter.getListCariSTT(params);
  }

  @Action
  async getDownloadListCariSTT(id: number) {
    const presenter = container.resolve(ListCariSTTPresenter);
    return presenter.getDownloadListCariSTT(id);
  }

  @Action
  async getDetailSttScan(id: number) {
    const presenter = container.resolve(ListCariSTTPresenter);
    return presenter.getDetailSttScan(id);
  }

  @Action
  searchSttScan(payload: SearchSttScanApiRequest) {
    const presenter = container.resolve(ListCariSTTPresenter);
    return presenter.searchSttScan(payload);
  }

  @Action
  searchSttManifest() {
    const presenter = container.resolve(ListCariSTTPresenter);
    return presenter.searchSttManifest();
  }

  @Action
  getSearchSttScanList(params: SearchSttFilter) {
    const presenter = container.resolve(ListCariSTTPresenter);
    return presenter.getSearchSttScanList(params);
  }
}
export const ListCariSTTController = getModule(ListCariSTTStore);
